import { render, staticRenderFns } from "./tabs-tabs.vue?vue&type=template&id=fc2f2714&scoped=true&"
import script from "./tabs-tabs.vue?vue&type=script&lang=js&"
export * from "./tabs-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2f2714",
  null
  
)

export default component.exports